__turbopack_context__.v({
  "badge": "LiveBadge-module__e1Q0sa__badge",
  "badge-pulse": "LiveBadge-module__e1Q0sa__badge-pulse",
  "canary": "LiveBadge-module__e1Q0sa__canary",
  "dot": "LiveBadge-module__e1Q0sa__dot",
  "live": "LiveBadge-module__e1Q0sa__live",
  "mode": "LiveBadge-module__e1Q0sa__mode",
  "offline": "LiveBadge-module__e1Q0sa__offline",
  "reason": "LiveBadge-module__e1Q0sa__reason",
  "stale": "LiveBadge-module__e1Q0sa__stale",
  "syncing": "LiveBadge-module__e1Q0sa__syncing",
});
